module.exports = __webpack_public_path__ + "static/petronas-da902e02304f4e73f56b952ddcc0ae32.png";